// extracted by mini-css-extract-plugin
module.exports = {"sticky":"sticky_sticky_2hj8-","container":"sticky_container_NWRX4"};